import React, { CSSProperties } from "react";
import { SwitchProps } from "@mui/material/Switch";

import { useController } from "react-hook-form";
import { useSmartFormContext } from "components/SmartForm";
import { Tooltip } from "components/mui-styled-components/Tooltip";
import HelperText from "../HelperText";
import * as S from "./styles";

type SmartFormSwitchT = {
  name: string;
  label?: string;
  switchText?: string;
  helperText?: string | undefined;
  error?: boolean;
  disabled?: boolean;
  labelStyle?: CSSProperties;
  switchTextStyle?: CSSProperties;
  tooltipText?: string;
  disabledTooltipText?: string;
} & SwitchProps;

const SmartFormSwitch = ({
  label,
  name,
  switchText,
  helperText,
  error,
  tooltipText,
  disabledTooltipText,
  disabled = false,
  labelStyle = {},
  switchTextStyle = {},
  ...rest
}: SmartFormSwitchT) => {
  const { controllerProps } = useSmartFormContext();
  const { field } = useController({ ...controllerProps, name });

  return (
    <>
      {label && (
        <S.LabelGroupWrapper>
          <S.StyledFormLabel style={labelStyle}>{label}</S.StyledFormLabel>
        </S.LabelGroupWrapper>
      )}
      <S.StyledSwitchWrapper>
        <Tooltip placement="top-start" title={disabled ? disabledTooltipText : null}>
          <div>
            <S.StyledSwitch
              disabled={disabled}
              {...field}
              {...rest}
              sx={{ width: "22px", height: "15px", padding: "0px", marginRight: "9px" }}
            />
          </div>
        </Tooltip>
        <S.StyledSwitchText style={switchTextStyle}>{switchText}</S.StyledSwitchText>
        {tooltipText && (
          <Tooltip placement="top" title={<S.TooltipText>{tooltipText}</S.TooltipText>}>
            <S.TooltipIcon>!</S.TooltipIcon>
          </Tooltip>
        )}
      </S.StyledSwitchWrapper>
      <HelperText error={error}>{helperText}</HelperText>
    </>
  );
};

export default SmartFormSwitch;
